import React, { useEffect, useState, useRef } from 'react';
import Input from '../components/Input';
import Button from '../components/Button';
import Text from '../components/Text';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import CookieConsent, { Cookies, getCookieConsentValue, resetCookieConsentValue } from "react-cookie-consent";
import { getCookie, setCookie, killCoockie } from '../assets/js/helper';


function Login(props) {
    const [inputs, setInputs] = useState("");
    const [validation, setValidation] = useState(null);
    const form = useRef();
    const navigate = useNavigate();

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setValidation(null)
        console.log(name, value);
        setInputs((values) => ({ ...values, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        console.log({
            email: inputs.email,
            mdp: inputs.mdp
        })
        axios.post(`http://localhost:5000/apiRouter/login`, {
            email: inputs.email,
            mdp: inputs.mdp
        })
            .then(res => {
                console.log("res", res);
                console.log("res.data", res.data);
                if (res.data.status === "ok") {
                    setValidation(true);
                    setCookie('w-player', JSON.stringify(res.data), 356);
                    navigate("/home") 
                }
                if (res.data.status === "ko") {
                    setValidation(false);
                    // alert('compte inconnu')
                }
                // res.data.status === "ok" ? setValidation(true) : setValidation(false)
                // document.cookie = JSON.stringify(`w-player:${res.data}`)
                // localStorage.setItem("w-player", `${res.data}`);
                // setPlayercookies('w-player', JSON.stringify(res.data), { path: '/' })

            })

            .catch(function (error) {
                console.log('error', error.toJSON());
                setValidation(false)
            });
        // navigate('/ReadWord', { replace: true })

    };

    useEffect(() => {
        const wCookie = getCookie('w-player');
        // console.log("lenght wCookie",wCookie.lenght)

        if (!wCookie) {
            navigate("/login")
        }
        if (wCookie) {
            // alert('on redirige sur loginalready') 
            const wPlayer = JSON.parse(wCookie)
            console.log('wPlayer', wPlayer)
            wPlayer.token = ! null && navigate("/loginalready")
        }
    }, [])


    return (
        <div className="w-login row w-fullscreen">
            <div className='col-lg-6 bg-blue w-half-left'>
                <img className="w-img-xl" src="/img/categories/login.png" alt="login" />
            </div>
            <form ref={form} onSubmit={handleSubmit} className='col-lg-6 w-half-right'>
                <img className="w-img-lg" src="/img/categories/wordin_full.png" alt="login" />
                {
                    validation === true
                    &&
                    <Link to="/home">
                        <Text text="Super ! Vous êtes connecté !!! " classes="w-text-green-light " />
                    </Link>
                }
                {
                    validation === false
                    &&
                    <Link to="/login">
                        <Text text="Oups ! Worder non retrouvé." classes="w-text-red-m" />
                    </Link>
                }
                <Text text="Se connecter" classes="w-text-blue-l" />
                <input
                    name="email"
                    value={inputs.email || ""}
                    onChange={handleChange}
                    type="email"
                    placeholder="Email" className="w-input" required />
                <input
                    name="mdp"
                    value={inputs.mdp || ""}
                    onChange={handleChange}
                    type="password"
                    placeholder="Mot de passe" className="w-input" required />

                <Button text="Valider !" classes="w-btn-blue-lg" />

                <Link to="/signup">
                    <Text text="Pas de compte ? S’inscrire." classes="w-text-black-m" />
                </Link>
                <Link to="/forgotpassword">
                    <Text text="Mot de passe oublié ? " classes="w-text-gray-m" />

                </Link>
            </form>
            <CookieConsent
                location="bottom"
                buttonText="Bien sûr !"
                cookieName="w-coockies-acceptation"
                style={{ background: "#0179bf" }}
                buttonStyle={{ color: "#0179bf", fontSize: "13px", borderRadius: "50px", background: "#fff" }}
                expires={150}
            >
                Notre site utilise les coockies pour vous donner une meilleur expérience lors de son utilisation... <b>Avouez que c'est bon les coockies 🍪🍪🍪!</b>

            </CookieConsent>
        </div>
    );
}

export default Login;